export const confirmModalTranslationEN = {
  Confirm_Modal: {
    cancel: 'Cancel',
    ok: 'OK',
  },
};
